module.exports = __webpack_public_path__ + "img/joshua_1x1.bad74ab2.webp";